<div class="rvs">
  <!-- the first line: the title, the average with its stars; the second: the themes, the platforms
       and the downloads (owner 2026-10-11) -->
  <div class="rvs-head">
    <div class="rvs-line">
      <h3 class="rvs-title">Loved by Users</h3>
      <span class="rvs-score" *ngIf="loaded && average; else scoreSkeleton">
        <span class="rvs-score-num">{{ average }}</span>
        <span class="rvs-stars" role="img" [attr.aria-label]="average + ' out of 5 stars'">
          <span class="rvs-star" *ngFor="let f of starFill" [style.--fill]="f * 100 + '%'" aria-hidden="true"></span>
        </span>
      </span>
      <ng-template #scoreSkeleton><span class="rvs-bar rvs-shimmer" style="width: 180px;" aria-hidden="true"></span></ng-template>
    </div>
    <span class="rvs-counts" *ngIf="counts.length">
      <ng-container *ngFor="let c of counts; let first = first"><span class="rvs-dot" *ngIf="!first" aria-hidden="true"></span><span class="rvs-num">{{ c.value }}</span> {{ c.label }}</ng-container>
    </span>
  </div>

  <!-- the wall: every column drifts upward at its own pace (each track carries its list twice, so
       the loop is seamless); the pointer over it holds it still to read -->
  <div class="rvs-grid" #grid data-drift-hold [style.--cols]="columns.length || 3">
    <ng-container *ngIf="loaded; else gridSkeleton">
      <div class="rvs-col" *ngFor="let col of columns; index as ci">
        <div class="rvs-track" [appDrift]="seconds( col, ci )" [driftStart]="start( ci )">
          <app-review-card *ngFor="let r of col" [review]="r"></app-review-card>
          <app-review-card *ngFor="let r of col" [review]="r" aria-hidden="true"></app-review-card>
        </div>
      </div>
    </ng-container>

    <ng-template #gridSkeleton>
      <div class="rvs-col" *ngFor="let c of skeletonColumns" aria-hidden="true">
        <div class="rvs-sk" *ngFor="let i of c">
          <div class="rvs-sk-head">
            <span class="rvs-sk-avatar rvs-shimmer"></span>
            <span class="rvs-sk-who">
              <span class="rvs-bar rvs-shimmer" style="width: 60%;"></span>
              <span class="rvs-bar rvs-shimmer" style="width: 40%;"></span>
            </span>
          </div>
          <span class="rvs-bar rvs-shimmer" style="width: 92%;"></span>
          <span class="rvs-bar rvs-shimmer" style="width: 64%;"></span>
        </div>
      </div>
    </ng-template>
  </div>

</div>
